import { useEffect } from "react";

/**
 * Gère la balise <meta name="robots"> directement dans le <head>.
 * Fiable quelle que soit la version de react-helmet (qui n'applique pas
 * toujours les meta robots sous React 19).
 * - Vitrine : content="index, follow, ..."
 * - GMAO privé : content="noindex, nofollow"
 * Chaque layout qui monte écrase la valeur, donc pas besoin de cleanup.
 */
const RobotsTag = ({ content }) => {
  useEffect(() => {
    let tag = document.head.querySelector('meta[name="robots"]');
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "robots");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  }, [content]);

  return null;
};

export default RobotsTag;
